define([
	"dojo/_base/declare",
	"dojo/_base/lang",
	"dojo/dom-construct",
	"csi",
	"csi/comm/Aspera",
	"csi/config",
	"csi/def",
	"csi/def/Field",
	"csi/def/Relationship",
	"csi/form/Widget",
	"csi/html",
	"csi/locale",
	"csi/utility/fileUtility",
	"csi/xml",
	"csi/xml/Query"
], function(declare, lang, domConstruct, csi, Aspera, config, def, Field, Relationship, Widget, html, locale, {getFileNameWithoutExtension}, xml, Query) {

	var SOURCE_TYPE = "SourceType";
	var SOURCE_FILE = "SourceFile";
	var SOURCE_OBJECT_REVISION = "SourceObjectRevision";
	var SOURCE_OBJECT_TYPE = "SourceObjectType";
	var SOURCE_WEB_NAME = "CDocSourceWebName";
	var SOURCE_WEB_URL = "SourceWebURL";
	var SUBTYPE = "Subtype";

	return declare(Widget, {

		_sourceObjectStore: null,
		_supplierCDocSubtypeStore: null,
		_isSpecialSupplierCDoc: false,

		/** @param {Object} asperaData - internal structure to hold Aspera connection data between aspera calls */
		asperaData: null,
		uploadAsperaFile: null,
		fileIndexNode: null,
		warnMsg: "",
		_setCheckMessageAttr: {node: "checkMessageNode", type: "innerText"},

		/**
		 * @override
		 * Ensure value for SourceObjectRevision field is a TestRunRevision URL
		 */
		_getFormReportFieldValue(formNode, field) {
			const value = this.inherited(arguments);

			if (field.m_id === SOURCE_OBJECT_REVISION) {
				const node = this.cacheView.get(value);
				if (node?.$Type === "TestRun") {
					return node.CurrentRevision;
				}
			}

			return value;
		},

		_resolveView: function() {
			// summary: add type and source fields
			var subtypeField = this.insertField(lang.mixin(new Field(), {
				m_id: SUBTYPE,
				m_bRequired: true
			}), 0);
			var fd = this.getContext().fd;
			var action = fd ? fd.getAction() : null;
			var right = null;
			if (!action) {
				// do nothing - it's needed to be able to load the view without a context (for ex. in Debug.RequestGenerator)
			} else if (action.m_id == "NewSpecial") {
				this._isSpecialSupplierCDoc = true;
				right = "None";
				subtypeField.m_relationship = lang.mixin(new Relationship(), {
					m_typeNode: "ContractualDocumentSubtype",
					m_query: new Query()
						.Attr("Active", xml.OP_EQUALS, "true", "Child:Settings")
						.Attr("RequiresAcknowledgement", xml.OP_EQUALS, "true", "Child:Settings")
				});
			}
			//DE17136
			else if (action.m_id == "NewFromTestRunTemplate" || action.m_id == "CreateContractualDocument") {
				right = "None";
			}

			this.insertField(lang.mixin(new Field(), {m_id: SOURCE_TYPE, m_bRequired: true, m_right: right}), 1);

			this.insertField(lang.mixin(new Field(), {
				m_id: SOURCE_FILE,
				m_path: "Child:CurrentRevision",
				m_typeControl: def.FIELD_FILE,
				m_onDraw: "onDrawCreateFileIndexNode"
			}), 2);
			this.insertField(lang.mixin(new Field(), {
				m_id: SOURCE_OBJECT_TYPE,
				m_path: "Child:CurrentRevision",
				m_bRequired: true,
				m_right: right
			}), 3);
			this.insertField(lang.mixin(new Field(), {
				m_id: SOURCE_OBJECT_REVISION,
				m_path: "Child:CurrentRevision",
				m_right: right,
				// prevent form from breaking when doing Save & New and switching to and from SourceType
				omitFromReport: true
			}), 4);
			this.insertField(lang.mixin(new Field(), {
				m_label: SOURCE_WEB_NAME,
				m_typeControl: def.FIELD_TEXT
			}), 5);
			this.insertField(lang.mixin(new Field(), {m_id: SOURCE_WEB_URL, m_path: "Child:CurrentRevision"}), 6);
			this.inherited(arguments);
		},

		_updateFieldVisibility: function(/*Field?*/field) {
			// summary: reset hidden field values

			if (this._isSpecialSupplierCDoc) {
				// if special supplier cdoc set the value of source type to file
				this.setFieldValue(SOURCE_TYPE, "CDocSourceType:File");
			}

			var changed = this.inherited(arguments);
			var hasEffectivity = false;
			var hasRenewalPeriod = false;
			var source = this.defView.getFieldValue(SOURCE_TYPE);
			var subtypeUrl = this.defView.getFieldValue(SUBTYPE);

			this.uploadAsperaFile = source == "CDocSourceType:File" ? true : false;

			if (subtypeUrl) {
				hasEffectivity = config.getSubtypeSetting(subtypeUrl, "HasEffectivity");

				if (hasEffectivity && config.getSubtypeSetting(subtypeUrl, "RequiresAcknowledgement")) {
					hasRenewalPeriod = config.getSubtypeSetting(subtypeUrl, "HasRenewalPeriod");
				}
			}

			changed |= this.setFieldHidden(SOURCE_FILE, source != "CDocSourceType:File");
			changed |= this.setFieldHidden(SOURCE_OBJECT_REVISION, source != "CDocSourceType:Object");
			changed |= this.setFieldHidden(SOURCE_OBJECT_TYPE, source != "CDocSourceType:Object");
			changed |= this.setFieldHidden(SOURCE_WEB_NAME, source != "CDocSourceType:Web");
			changed |= this.setFieldHidden(SOURCE_WEB_URL, source != "CDocSourceType:Web");
			changed |= this.setFieldHidden("EffectiveTo", !hasEffectivity);
			changed |= this.setFieldHidden("EffectiveFrom", !hasEffectivity);

			if (hasRenewalPeriod) {
				// the subtype has renewal period
				// if the renewal period field is empty, set the default value to 1 year
				if (this.getFieldValue("RenewalPeriod") == "CDocRenewalPeriod:") {
					this.setFieldValue("RenewalPeriod", "CDocRenewalPeriod:1 year");
				}
			} else {
				// the subtype has no renewal period
				// clear the field renewal period 
				this.setFieldValue("RenewalPeriod", "CDocRenewalPeriod:");
			}

			changed |= this.setFieldHidden("RenewalPeriod", !hasRenewalPeriod);

			return changed;
		},

		getValueForField: function(/*Field*/field, /*Node?*/node) {
			// summary: init source-object drop-down as the master, not the rev
			var value = this.inherited(arguments);
			if (field.getControlName() == SOURCE_OBJECT_REVISION && value != csi.EMPTY_URL) {
				value = this.cacheView.getNode(value).Master;
			}
			return value;
		},

		/**
		 * @override
		 * Replace standard "Select File" button with custom one to use with Aspera,
		 */
		onDrawCreateFileIndexNode: function(defView, field, value, div, control, widgetParam) {
			var sourceFieldDom = this.getFieldRow(SOURCE_FILE);
			var sourceFieldMsgContainer = domConstruct.place(html.create("tr", {
				"class": "csi-3Dform-fileIndex-row"
			}), sourceFieldDom, "after");

			var sourceFieldMsgRow = html.create("td", {
				"colspan": "3"
			}, sourceFieldMsgContainer);

			this.fileIndexNode = html.create("div", {
				"class": "csi-3Dform-fileIndex-container"
			}, sourceFieldMsgRow);

			if (Aspera.isEnabled()) {
				html.clear(div);
				field.m_control = html.create("button", {
					innerText: locale.resource("ChooseFile"),
					"data-csi-automation": "field-ContractualDocument-Form-SourceFile",
					_setdatacsiautomationattr: "",
					name: "SourceFile",
					type: "file",
					onclick: (event) => this._onClickFileField(event)
				}, div);
			}
		},

		/**
		 * @override
		 * On file select check if its a valid zip file
		 * @param {Obj} defView
		 * @param {Field} field
		 * @param {Any} value
		 * @param {Object} params - parameter from base class
		 * @param {Object} asperaFile - Aspera replacement for File blob object. Can't be used for Zip parsing
		 */
		_onChangeFileField: function(defView, field, value, params, asperaFile) {

			//Set wanted file object
			const fileToRead = asperaFile || field.m_control.files[0];
			$(this.fileIndexNode).empty();

			if (!fileToRead) {
				//fill in default message when no files are selected
				this.onZipFile(true);
			} else {
				//pre-fill Document name field from file name if the field is blank
				const textField = this.getField(xml.ATTR_NAME);

				if (textField.isDefaultValue() || !textField.getValue()) {
					let fileName = getFileNameWithoutExtension(fileToRead.name);
					fileName = fileName.substring(fileName.lastIndexOf('/') + 1);
					fileName = fileName.substring(fileName.lastIndexOf('\\') + 1);
					this.setFieldValue(textField, fileName);
				}
			}

			field.errorMessage = "";
			this.warnMsg = "";
			if (asperaFile) {
				this.onZipFile(true, asperaFile.name);
			}
		},

		/**
		 * Creates the file message row
		 * @param {boolean} [bIsRequired]
		 * @param {string} [fileName]
		 */
		onZipFile: function(bIsRequired, fileName) {
			//move required items to top of the row
			var messageRowNode = html.create("div", {
				"class": "csi-3Dform-fileIndex-row"
			}, this.fileIndexNode, bIsRequired && "first");

			html.create("div", {
				innerHTML: (bIsRequired ? (fileName ? 'check_circle' : 'brightness_1') : '&nbsp;'),
				"class": "csi-3Dform-fileIndex-left" + (bIsRequired ? (" material-icons " + (fileName ? "csi-status-ok" : "")) : "")
			}, messageRowNode);

			var requiredFileText = locale.resource("3DObjectFiles");

			this.checkMessageNode = html.create("div", {
				"class": "csi-3Dform-check-message"
			}, messageRowNode);
			this.set("checkMessage", fileName || requiredFileText);
		},

		/**
		 * Custom "Select File" button callback
		 * @param {MouseEvent} event
		 */
		_onClickFileField: function(event) {
			event.preventDefault();
			var self = this;
			Aspera.selectFile().then(
				function(data) {
					self.asperaData = data;
					var field = self.getField(SOURCE_FILE);
					self._onChangeFileField(null, field, null, null, data.files[0]);
				},
				function(msg) {
					// suppress error if user cancel file selection
				}
			);
		}
	});
});
